"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpsertOrderMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class UpsertOrderMapper {
    toDomain(result) {
        const hasError = !!lodash_1.default.get(result, "error");
        const order = lodash_1.default.get(result, "data.order");
        return {
            hasError,
            order,
        };
    }
}
exports.UpsertOrderMapper = UpsertOrderMapper;
